import TablaConciliacion from "../../../TablaConciliacion";

function TablaAlma() {
  return <TablaConciliacion nombreUseCase="ALMA" titulo="ALMA" />;
}

export default TablaAlma;
